/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible button icon positions.
 */
export type ButtonIconPosition = ButtonIconLeft | ButtonIconRight;

/**
 * Button icon left position type.
 */
export type ButtonIconLeft = typeof BUTTON_ICON_LEFT;

/**
 * Button icon right position type.
 */
export type ButtonIconRight = typeof BUTTON_ICON_RIGHT;

/**
 * Button icon left position constant.
 */
export const BUTTON_ICON_LEFT = 'left';

/**
 * Button icon right position constant.
 */
export const BUTTON_ICON_RIGHT = 'right';
